<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};

let lastTouchEnd = 0;

document.addEventListener('touchstart', function (event) {
  if (event.touches.length > 1) {
    event.preventDefault(); // 多指触控直接阻止缩放
  }
}, { passive: false });

document.addEventListener('touchend', function (event) {
  const now = Date.now();
  if (now - lastTouchEnd <= 300) {
    event.preventDefault(); // 快速连续触摸被视为双击
  }
  lastTouchEnd = now;
}, false);

// 防止双击触发 dblclick 事件缩放
document.addEventListener('dblclick', function (event) {
  event.preventDefault();
}, false);

</script>


